import { ElementRef, Injectable } from '@angular/core';

import { Network, DataSet, Node, Edge } from 'visjs-network';

import { InstanceService as ResourceInstanceService } from '@serengeti/serengeti-resource';
import { CatalogInstanceService as ResourceCatalogInstanceService } from '@serengeti/serengeti-resource';
import { CatalogInstanceService as SoftwareCatalogInstanceService } from '@serengeti/serengeti-app';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ProjectTopologyService {

	nodesHash: any;
	nodesArray: any[];
	edgesArray: any[];
	nodes: Node;
	edges: Edge;
	network : Network;
  
	constructor(
		private router: Router,
		private resourceInstanceService: ResourceInstanceService,
		private resourceCatalogInstanceService: ResourceCatalogInstanceService,
		private softwareCatalogInstanceService: SoftwareCatalogInstanceService
	) { }

	build(topology: ElementRef, projects: any[], includeUser = false) {
		if (projects) {
			const tenantIds = [];

			projects.forEach((project: any) => {
				tenantIds.push(project.id);
			});

			this.nodesArray = [];
			this.edgesArray = [];
	
			if (includeUser) {
				this.nodesArray.push({
					id: 1,
					label: '사용자 프로젝트 목록',
					image: {
						unselected: '/assets/images/topology/user.png',
						selected: '/assets/images/topology/user.png'
					},
					imagePadding: 5,
					shape: "image",
					size: 32
				});	
			}
	
			this.nodesHash = {};

			if (tenantIds.length === 0) {
				this._rebuildTopologyNetwork(topology);
				return;
			} else {
				projects.forEach((project: any) => {
					const data = project;
	
					if (!this.nodesHash[data.id]) {
						const node = {
							id: data.id,
							label: data.name,
							project: project,
							image: {
								unselected: '/assets/images/topology/project.png',
								selected: '/assets/images/topology/project.png'
							},
							imagePadding: 5,
							shape: "image",
							size: 32
						};
		
						if (!this.nodesHash[node.id]) {
							this.nodesArray.push(node);
							this.nodesHash[node.id] = node;
							if (includeUser) {
								this.edgesArray.push({
									from: 1,
									to: data.id
								});	
							}	
						}
					}
				});

				this.softwareCatalogInstanceService.search(tenantIds, null, null, null, null, null, 0, 10000).subscribe((serviceCatalogInstances: any) => {
					this.resourceCatalogInstanceService.instances(tenantIds, null, null, null, 0, 10000).subscribe((resourceCatalogInstances: any) => {
						this.resourceInstanceService.tenant(tenantIds, null, null, null, 0, 10000).subscribe((resourceInstances: any) => {
							serviceCatalogInstances.content.forEach((instance: any) => {
								const node = {
									id: instance.id,
									label: instance.name,
									serviceCatalog: instance,
									image: {
										unselected: '/assets/images/topology/service-catalog.png',
										selected: '/assets/images/topology/service-catalog.png'
									},
									imagePadding: 5,
									shape: "image",
									size: 32
								};
			
								if (!this.nodesHash[node.id]) {
									this.nodesArray.push(node);
									this.nodesHash[node.id] = node;
				
									const parent = this.nodesHash[instance.tenantId];
				
									if (parent) {
										this.edgesArray.push({
											from: parent.id,
											to: instance.id
										});	
									}	
									instance.templates.forEach((template: any) => {
										this.buildTemplate(node, template);
									});	
								}
							});
			
							const resourceInstanceHash = {};
							resourceInstances.content.forEach((resourceInstance: any, index: number) => {
								resourceInstanceHash[resourceInstance.id] = resourceInstance;
								resourceInstance.index = index;
							});
							resourceCatalogInstances.content.forEach((resourceCatalogInstance: any) => {
								if (this.nodesHash[resourceCatalogInstance.id]) {
									this.nodesHash[resourceCatalogInstance.id].resourceCatalog = resourceCatalogInstance;
								} else {
									const projectNode = this.nodesHash[resourceCatalogInstance.tenantId];
									const node = {
										id: resourceCatalogInstance.id,
										label: resourceCatalogInstance.name,
										resourceCatalog: resourceCatalogInstance,
										image: {
											unselected: '/assets/images/topology/resource-catalog.png',
											selected: '/assets/images/topology/resource-catalog.png'
										},
										imagePadding: 5,
										shape: "image",
										size: 32
									};
				
									if (!this.nodesHash[node.id]) {
										this.nodesArray.push(node);
										this.nodesHash[node.id] = node;
		
										this.edgesArray.push({
											from: projectNode.id,
											to: node.id
										});
										const parentNode = node;
										resourceCatalogInstance.runtimes.forEach((runtime: any) => {
											const node = {
												id: runtime.id,
												label: runtime.name,
												resourceTemplate: runtime,
												image: {
													unselected: '/assets/images/topology/resource-group.png',
													selected: '/assets/images/topology/resource-group.png'
												},
												imagePadding: 5,
												shape: "image",
												size: 32
											};
											this.nodesArray.push(node);
											this.nodesHash[node.id] = node;
			
											this.edgesArray.push({
												from: parentNode.id,
												to: node.id
											});	
										});	
									}
								}
								resourceCatalogInstance.runtimes.forEach((runtime: any) => {
									runtime.resources.forEach((resource: any) => {
										const parentNode = this.nodesHash[runtime.id];
										const instance = resourceInstanceHash[resource.resourceId];
	
										if (instance) {
											resourceInstances.content.splice(instance.index, 1);
											if (resourceInstances.content.length > instance.index) {
												for (let index = instance.index; index < resourceInstances.content.length; index ++) {
													resourceInstances.content[index].index --;
												}
											}

											if (!this.nodesHash[instance.id]) {
												const resourceNode = {
													id: instance.id,
													label: instance.name,
													resource: instance,
													image: {
														unselected: '/assets/images/topology/resource-instance.jpeg',
														selected: '/assets/images/topology/resource-instance.jpeg'
													},
													imagePadding: 5,
													shape: "image",
													size: 32
												};
												this.nodesArray.push(resourceNode);
												this.nodesHash[instance.id] = resourceNode;
						
												if (parentNode) {
													parentNode.resourceTemplate = runtime;
		
													this.edgesArray.push({
														from: parentNode.id,
														to: resourceNode.id
													});
												} else {
													this.edgesArray.push({
														from: 1,
														to: resourceNode.id
													});
												}	
											}
										}
									});
								});
							});
							if (resourceInstances.content.length > 0) {
								resourceInstances.content.forEach((instance: any) => {
									if (!this.nodesHash[instance.id]) {
										const parentNode = this.nodesHash[instance.tenantId];
										const resourceNode = {
											id: instance.id,
											label: instance.name,
											resource: instance,
											image: {
												unselected: '/assets/images/topology/resource-instance.jpeg',
												selected: '/assets/images/topology/resource-instance.jpeg'
											},
											imagePadding: 5,
											shape: "image",
											size: 32
										};

										if (!this.nodesHash[resourceNode.id]) {
											this.nodesArray.push(resourceNode);
											this.nodesHash[resourceNode.id] = resourceNode;
					
											if (parentNode) {
												this.edgesArray.push({
													from: parentNode.id,
													to: resourceNode.id
												});
											} else {
												this.edgesArray.push({
													from: 1,
													to: resourceNode.id
												});
											}	
										}
									}
								});
							}
							this._rebuildTopologyNetwork(topology);
						});
					});
				});	
			}
		}
	}

	buildServiceCatalog(topology: ElementRef, catalogInstanceId: string) {
		if (catalogInstanceId) {
			this.softwareCatalogInstanceService.get(catalogInstanceId).subscribe((instance: any) => {
				const tenantIds = [];
				tenantIds.push(instance.tenantId);
				this.resourceCatalogInstanceService.instances(tenantIds, null, null, null, 0, 10000).subscribe((resourceCatalogInstances: any) => {
					this.resourceInstanceService.tenant(tenantIds, null, null, null, 0, 10000).subscribe((resourceInstances: any) => {
						this.nodesArray = [];
						this.edgesArray = [];
				
						this.nodesHash = {};
						const node = {
							id: instance.id,
							label: instance.name,
							serviceCatalog: instance,
							image: {
								unselected: '/assets/images/topology/service-catalog.png',
								selected: '/assets/images/topology/service-catalog.png'
							},
							imagePadding: 5,
							shape: "image",
							size: 32
						};

						if (!this.nodesHash[node.id]) {
							this.nodesArray.push(node);
							this.nodesHash[node.id] = node;
		
							const parent = this.nodesHash[instance.tenantId];
		
							if (parent) {
								this.edgesArray.push({
									from: parent.id,
									to: instance.id
								});	
							}
							instance.templates.forEach((template: any) => {
								this.buildTemplate(node, template);
							});
			
							const resourceInstanceHash = {};
							resourceInstances.content.forEach((resourceInstance: any) => {
								resourceInstanceHash[resourceInstance.id] = resourceInstance;
							});
							resourceCatalogInstances.content.forEach((resourceCatalogInstance: any) => {
								if (this.nodesHash[resourceCatalogInstance.id]) {
									this.nodesHash[resourceCatalogInstance.id].resourceCatalog = resourceCatalogInstance;
								}
								resourceCatalogInstance.runtimes.forEach((runtime: any) => {
									runtime.resources.forEach((resource: any) => {
										const parentNode = this.nodesHash[runtime.id];
										const instance = resourceInstanceHash[resource.resourceId];
	
										if (instance && parentNode) {
											if (!this.nodesHash[instance.id]) {
												const resourceNode = {
													id: instance.id,
													label: instance.name,
													resource: instance,
													image: {
														unselected: '/assets/images/topology/resource-instance.jpeg',
														selected: '/assets/images/topology/resource-instance.jpeg'
													},
													imagePadding: 5,
													shape: "image",
													size: 32
												};
												this.nodesArray.push(resourceNode);
												this.nodesHash[resourceNode.id] = resourceNode;
						
												parentNode.resourceTemplate = runtime;
		
												this.edgesArray.push({
													from: parentNode.id,
													to: resourceNode.id
												});	
											}
										}
									});
								});
							});
							this._rebuildTopologyNetwork(topology);	
						}
					});
				});
			});
		}
	}

	buildTemplate(parentNode: any, template: any) {
		const templateNode = {
			id: template.resourceRuntimeId,
			label: template.name,
			image: {
			},
			imagePadding: {
				top: 5,
				right: 5,
				bottom: 5,
				left: 5
			},
			shape: "image",
			size: 32
		} as any;

		if (!this.nodesHash[templateNode.id]) {
			if (template.resourceType === 'ResourceCatalog') {
				templateNode.resourceCatalog = template;
				templateNode.image.unselected = '/assets/images/topology/resource-catalog.png'
			} else {
				templateNode.resourceTemplate = template;
				templateNode.image.unselected = '/assets/images/topology/resource-group.png'
			}
			templateNode.image.selected = templateNode.image.unselected;
	
			this.nodesArray.push(templateNode);
			this.nodesHash[templateNode.id] = templateNode;
	
			this.edgesArray.push({
				from: parentNode.id,
				to: templateNode.id
			});
	
			if (template.children) {
				template.children.forEach((childTemplate: any) => {
					this.buildTemplate(templateNode, childTemplate);
				});
			}	
		}
	}

	_rebuildTopologyNetwork(topology: ElementRef) {
		const zoomMinLimit = 0.49;
		const zoomMaxLimit = 3.01;
		var nodes = new DataSet(this.nodesArray);
		var edges = new DataSet(this.edgesArray);
		var data = {
			nodes: nodes,
			edges: edges
		};
		let lastZoomPosition = {
			x:0,
			y:0
		};
		var options = {
		};
		var network = new Network(topology.nativeElement, data, options);
		network.on('selectNode', ($event: any) => {
			if ($event.nodes.length > 0) {
				this.goProject($event.nodes[0]);
			}
		});
		network.on("zoom", () => { 
			if (network.getScale() <= zoomMinLimit) {
				network.moveTo({
					position: lastZoomPosition,
					scale: zoomMinLimit
				});
			} else if (network.getScale() >= zoomMaxLimit) {
				network.moveTo({
					position: lastZoomPosition,
					scale: zoomMaxLimit
				});
			} else {
				lastZoomPosition = network.getViewPosition();
			}
		});
		network.on("dragEnd",function(params){
			lastZoomPosition = network.getViewPosition()
		});	
	}

	goProject(nodeId: string) {
		if (this.nodesHash) {
			const node = this.nodesHash[nodeId];
			
			if (node) {
				if (node.project) {
					this.router.navigate(['/main', { outlets: { content: 'service/project/detail/' + node.project.id + '/' }}]);
				} else if (node.serviceCatalog) {
					this.router.navigate(['/main', { outlets: { content: 'software/catalog/instance/detail/' + node.id + '/' }}]);
				} else if (node.resourceCatalog) {
					this.router.navigate(['/main', { outlets: { content: 'resource/catalog/instance/detail/' + node.id + '/' }}]);
				} else if (node.resourceTemplate) {
					this.router.navigate(['/main', { outlets: { content: 'resource/catalog/instance/detail/' + node.resourceTemplate.catalogInstance.id + '/' }}]);
				} else if (node.resource) {
					this.router.navigate(['/main', { outlets: { content: 'resource/instance/detail/' + node.id + '/' }}], { queryParams: { selectedTenantId: node.resource.tenantId }});
				}
			}
		}
	}
}
